import nfts from './nfts'
import axios from 'axios'
import {get} from './keyvalue'
import {ethers} from 'ethers'
import {toBN, toDec} from './bn'

const wait = (n) => new Promise(r=>setTimeout(()=>r(),n))

const getIndex = async () => {
    if(window._index) return window._index
    window._index = await get()
    return window._index
}

const getURLsFromIndex = async () => {
    let index = await getIndex()
    return Object.keys(index.urls)
}

const getMeta = async (url) => {
    //url = url.replace('ipfs.infura','nftupload.infura-ipfs')
    let ret = await axios.get(url)
    let meta = ret.data
    meta.url = url
    meta.available = async () => await nfts.yieldSale.numAvailable(url)
    return meta
}

const getAllMeta = async () => {
    let urls = await getURLsFromIndex()
    return await Promise.all(urls.map(async url=> await getMeta(url)))
}

const getTokenIds = async (url) => {
    //let _url = url.replace('nftupload.infura-ipfs','ipfs.infura')
    let index = await getIndex()
    return index.urls[url]
}

const ownerOf = async(tokenId) => {
    console.log(tokenId)
    
    try{
        let owner =  await nfts.yieldToken.ownerOf(tokenId)  
        return {owner,tokenId}    
    } catch(e){
        console.log(e)
        await wait(100)
        return await ownerOf(tokenId)
    }
    
}

const getTokenId = async (url) => {
    console.log(url)
    let owner = await nfts.yieldToken.owner()    
    let tokenIDs = await getTokenIds(url)
    
    let start = 0
    let end = start + 10
    if(tokenIDs.length<end) end = tokenIDs.length
    let tokenId = -1
    while(start<tokenIDs.length){
        let ar = []
        for(let i=start; i<end; i++){
            ar.push(tokenIDs[i])
        }
        console.log('getting tokens')
        console.log(ar)
        let tokens = await Promise.all(ar.map(async tokenId => await ownerOf(tokenId)))
        //let tokens = await ownerOf(ar[0])
        
        let available = tokens.filter(token => token.owner===owner)
        if(available.length>0){
            tokenId = available[0].tokenId
            break
        }
        
        start += 10
        end += 10
        await wait(10)
    }
    console.log('got tokenId ' + tokenId)
    return tokenId
    
  // return 1
}

export {getAllMeta as getMeta, getTokenIds, getTokenId}